import React from "react";
import { Container } from "react-bootstrap";

const InnerHero = ({ title, subtitle, bgImage }) => {
    return (
        <section
            className="inner-hero"
            style={{
                backgroundImage: `linear-gradient(
          rgba(0,0,0,0.65),
          rgba(0,0,0,0.65)
        ), url(${bgImage})`,
            }}
        >
            <Container>
                <div className="inner-hero-content fade-up">
                    <h1>{title}</h1>
                    <p>{subtitle}</p>
                </div>
            </Container>
        </section>
    );
};

export default InnerHero;
